import { IRouteConfig } from '@/router/types';

export default [
  {
    path: '',
    component: () => import('@/layouts/main/index.vue'),
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/modules/common/views/home/index.vue'),
        meta: {
          title: '首页',
          auth: true,
        },
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('./views/login/index.vue'),
    meta: {},
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('./views/error-page/404.vue'),
    meta: {
    },
  },

  {
    path: '/403',
    name: 'NoAuth',
    component: () => import('./views/error-page/403.vue'),
    meta: {},
  },

  {
    path: '/401',
    name: 'NoLogin',
    component: () => import('./views/error-page/401.vue'),
    meta: {},
  },
  {
    path: '/select-tenant',
    name: 'SelectTenant',
    component: () => import('./views/select-tenant/index.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/session-manage',
    name: 'SessionManage',
    component: () => import('./views/session-manage/index.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/redirect',
    component: () => import('@/layouts/main/index.vue'),
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('./views/redirect/index.vue'),
        meta: {},
      },
    ],
  },
  {
    path: '/oauth2',
    // redirect: '/oauth2/dingtalk',
    component: () => import('@/layouts/default/index.vue'),
    children: [
      {
        path: 'dingtalk',
        name: 'DingTalk',
        component: () => import('./views/oauth2/dingtalk/index.vue'),
        meta: {},
      },
      {
        path: 'wechat',
        name: 'WeChat',
        component: () => import('./views/oauth2/wechat/index.vue'),
        meta: {},
      },
      {
        path: 'err',
        name: 'Oauth2Err',
        component: () => import('./views/oauth2/error/index.vue'),
        meta: {},
      }
    ],
  }
] as IRouteConfig[];
